import { NAV_ITEMS } from "../../constants/navItems";
import { st } from "../../constants/styles";

const Sidebar = ({ active, setActive, user, onSignOut, loading }) => {
  if (!user) return null;

  return (
    <div style={st.sidebar}>
      <div style={st.sidebarHeader}>
        <div
          style={st.avatarCircle}
        >{`${user.firstName[0]}${user.lastName[0]}`}</div>
        <div>
          <p style={st.sidebarName}>{`${user.firstName} ${user.lastName}`}</p>
          <p style={st.sidebarEmail}>{user.email}</p>
        </div>
      </div>

      {NAV_ITEMS.map((item) => (
        <div
          key={item.key}
          style={st.navItem(active === item.key)}
          onClick={() => setActive(item.key)}
        >
          {item.icon} {item.label}
        </div>
      ))}

      <button
        onClick={onSignOut}
        style={st.signOutBtn(loading)}
        disabled={loading}
      >
        {loading ? "Signing out..." : "Sign Out"}
      </button>
    </div>
  );
};

export default Sidebar;
